// @flow
import gql from "graphql-tag"
import type { Query } from "common/graphql/types"
import type {
  ProductGroupCountryAggregator,
  Country,
  GooglePlace,
} from "./types"

export const listCountriesPerProductGroupQuery: Query<
  ProductGroupCountryAggregator[]
> = {
  gql: gql`
    query listCountriesPerProductGroupQuery {
      location {
        listCountriesPerProductGroup {
          name
          countries {
            name
            locations {
              name
            }
          }
        }
      }
    }
  `,
  selector: ["location", "listCountriesPerProductGroup"],
}

export const listCountries: Query<
    Country[],
  > = {
  gql: gql`
    query listCountries {
      location {
        listCountries {
          id
          name
          locations {
            id
            name
          }
        }
      }
    }
  `,
  selector: ["location", "listCountries"],
}

export const getDetail: Query<
  {
    place: GooglePlace,
  },
  {
    placeId: string,
  },
> = {
  gql: gql`
    query getDetail($placeId: String!) {
      googlePlaces {
        detail(filter: { placeId: $placeId }) {
          placeId
          affiliateName
          addressComponents {
            long_name
            short_name
            types
          }
          formattedAddress
          formattedPhoneNumber
          formattedOpeningHours
          photos
          website
          geometry {
            lat
            lng
          }
        }
      }
    }
  `,
  transform: data => ({
    // $Ramda
    place: {
      placeId: data.googlePlaces.detail.placeId,
      affiliateName: data.googlePlaces.detail.affiliateName,
      affiliateEmail: "",
      formattedPhoneNumber: data.googlePlaces.detail.formattedPhoneNumber,
      formattedAddress: data.googlePlaces.detail.formattedAddress,
      website: data.googlePlaces.detail.website,
      photos: data.googlePlaces.detail.photos,
      lat: data.googlePlaces.detail.geometry.lat,
      lng: data.googlePlaces.detail.geometry.lng,
      addressComponents: data.googlePlaces.detail.addressComponents.map(
        element => {
          return {
            types: element.types,
            long_name: element.long_name,
            short_name: element.short_name,
          }
        },
      ),
      formattedOpeningHours: data.googlePlaces.detail.formattedOpeningHours
        ? JSON.parse(data.googlePlaces.detail.formattedOpeningHours)
            .openingHours
        : undefined,
    },
  }),
}



// WEBPACK FOOTER //
// ./src/data/locations/queries.js